import React, { Component } from "react";
import { Grid, Row, Col } from "react-bootstrap";
import ReactTable from "react-table";
import "react-table/react-table.css";
import _ from 'lodash';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { NavLink } from "react-router-dom";

import config from 'config';
import Button from "components/CustomButton/CustomButton.jsx";
import Card from "components/Card/Card.jsx";
import { connect } from 'react-redux';
import stopActions from 'actions/stop.actions';

class Stops extends Component {
  constructor(props) {
    super(props);
    this.fetchData = this.fetchData.bind(this);
    this.fetchDataWithDebounce = _.debounce(this.fetchData, 1000);
    this.state = {
      criteria: {
        limit: config.pageSize,
        offset: 0,
        filtered: "",
        sorted: ""
      }
    };
  }

  componentWillUpdate(props) {
    if(props.error) {
      this.props.addNotification({type: 'error', message: props.error});
    }
  }

  fetchData = (state, instance) => {
    let criteria = this.state.criteria;
    let newFilter = state.filtered.length > 0 ? JSON.stringify(state.filtered) : "";
    let newOrderer = state.sorted.length > 0 ? JSON.stringify(state.sorted) : "";
    if(criteria.filtered !== newFilter) {
      criteria['offset'] = 0;
      criteria['filtered'] = newFilter;
    }
    if(criteria.sorted !== newOrderer) {
      criteria['offset'] = 0;
      criteria['sorted'] = newOrderer;
    }
    if(criteria.limit !== state.pageSize) {
      criteria.limit = state.pageSize;
      criteria['offset'] = 0;
    }
    else {
      criteria['offset'] = Math.ceil(state.page * state.pageSize);
    }
    this.setState({criteria: criteria}, () => {
      this.props.dispatch(stopActions.getStops(criteria));
    });
  };

  deleteItem = item => {
    confirmAlert({
      title: 'Delete Stop',
      message: 'Are you sure you want to delete this stop?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.props.dispatch(stopActions.delete(item.original.id))
        },
        {
          label: 'No',
          onClick: () => ''
        }
      ]
    });
  }

  render() {
    const stops = this.props.stops || [];
        const loading = this.props.loading || false;
    const total = this.props.total || 0;
    const pageCount = Math.ceil(total / this.state.criteria.limit);
    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Stops"
                rightButton={
                  <NavLink to="/dashboard/stop"><Button type="button" fill bsStyle="info"><i className="fa fa-plus"></i>Add Stop</Button></NavLink>
                }
                ctTableFullWidth
                ctTableResponsive
                content={
                  <ReactTable
                    columns={[
                      {
                        Header: "Address",
                        accessor: "address"
                      },
                      {
                        Header: "City",
                        accessor: "city"
                      },
                      {
                        Header: "State",
                        accessor: "state"
                      },
                      {
                        Header: "Country",
                        accessor: "country"
                      },
                      {
                        Header: "Active",
                        accessor: "active",
                        Cell: row => (
                          <div>{row.original.active ? 'Active' : 'Inactive'}</div>
                        ),
                        filterable: false
                      },
                      {
                        Header: "Actions",
                        width: 100,
                        sortable: false,
                        filterable: false,
                        Cell: row => (
                          <div className="table-actions">
                            <NavLink to={"/dashboard/stops/"+row.original.id}><Button bsStyle="info" disabled={row.original.deleting} fill type="button"><i className="fa fa-edit"></i></Button></NavLink>
                          </div>
                        )
                      },
                    ]}
                    manual
                    data={stops}
                    pages={pageCount} // Display the total number of pages
                    loading={loading} // Display the loading overlay when we need it
                    onFetchData={this.fetchDataWithDebounce}
                    filterable
                    defaultPageSize={this.state.criteria.limit}
                    className="-striped -highlight"
                  />
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  let { items, loading, total, error } = state.stops;
    return { stops: items, loading, total, error };
}

export default connect(mapStateToProps)(Stops);
